<template>
  <transition name="dialog-fade">
    <div v-if="show">
      <div class="hint">
        <div class="hint-box" v-if="type==='img'"
             :class="{'hint-box-big':type==='big','hint-box-big-img':type==='img'}">
          <span class="text">
            <i class="icon"
               :class="img"></i><span :class="{'isWrap':isWrap}" v-html="message"></span>
          </span>
        </div>
        <div class="text-a" v-else>
          {{message}}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: "",
      time: "",
      callback: null,
      move: "",
      type: "",
      img: "",
    };
  },
  methods: {
    over() {
      if (!this.show) {
        clearTimeout(this.move);
        this.move = setTimeout(() => {
          this.callback && this.callback();
        }, 500);
      } else {
        clearTimeout(this.move);
        this.move = setTimeout(() => {
          this.show = false;
        }, this.time);
      }
    },
  },
  computed: {
    isWrap() {
      return this.message.indexOf("<br />") > -1 ? true : false;
    },
  },
  updated() {
    this.over();
  },
};
</script>

<style lang="less" rel="stylesheet/less">
// 显示过渡动画
.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 0.5s;
}

.dialog-fade-enter,
.dialog-fade-leave-to {
  opacity: 0;
}

.hint {
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  text-align: center;
  padding-top: 70%;
  .hint-box {
    display: inline;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 0.25rem 0.5rem;
    border-radius: 0.1rem;
    .text {
      position: relative;
      padding-left: 0.85rem;
      .icon {
        display: block;
        height: 0.6rem;
        width: 0.6rem;
        background-color: #666;
        position: absolute;
        left: 0;
        top: 50%;
        margin-top: -0.3rem;
      }
      span {
        display: inline-block;
        height: auto;
        text-align: left;
      }
      .isWrap {
        position: relative;
        top: 10px;
      }
      .success {
        background: url(../assets/images/icon_toast_success.png);
        background-size: 100% 100%;
      }
      .error {
        background: url(../assets/images/icon_toast_error.png);
        background-size: 100% 100%;
      }
      .loading {
        height: 0.68rem;
        width: 0.58rem;
        background: url(../assets/images/icon_toast_loading.png);
        background-size: 100% 100%;
      }
    }
  }
  .text-a {
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.8);
    color: #fff;
    padding: 0.25rem 0.5rem;
    border-radius: 0.1rem;
  }
  .hint-box-big {
    padding: 0.4rem 0.8rem;
    border-radius: 0.16rem;
  }
  .hint-box-big-img {
    padding: 0.55rem 0.65rem;
    border-radius: 0.16rem;
  }
}
</style>
